import type { IQRANavUtilsConsumerComponentInitProps } from 'common/utils/navigation/qraNavUtils'
import type { IQRAViewProps } from 'features/RiskManagement'
import type { IGraphsViewBaseProps } from 'features/RiskManagement/Components/Graphs'

// NOTE: Used by WIS long polling
export interface IQRASavedStateViewInfo {
  // REVIEW: Track things like last loaded system/line ids to enable caching?
  stateId: number
  // REVIEW: Track all assessments on state or track only on particular assessment page?
  inProcessAssessmentId?: number
  lastInProcessAssessmentId?: number
}

export interface IQRASavedStateSliceStates {
  stateViewInfo?: IQRASavedStateViewInfo
  detailsId?: number
}

export interface ISavedStateViewProps
  extends IQRAViewProps,
    ISavedStateRouteParams {}

export interface ISavedStateGraphsInitProps
  extends IGraphsViewBaseProps,
    ISavedStateRouteParams {}

export interface ISavedStateTableInitProps
  extends IQRANavUtilsConsumerComponentInitProps,
    ISavedStateRouteParams {}

export interface ISavedStateRouteParams {
  [SavedStateRouteParams.StateId]: string
  [SavedStateRouteParams.AssessmentId]?: string
}

export enum SavedStateRouteParams {
  StateId = 'stateId',
  AssessmentId = 'assessmentId'
}
